const attendant  = {
    implementationKpi: {
        icon: 'file-done',
        text: 'Pelaksanaan KPI',
        route: 'implementation',
        role: {
            performance: [ 'attendant' ],
        },
        children: {
            reportResult: {
                icon: null,
                text: 'Business Result',
                route: 'admin.performance.implementation.business-result',
                role: {
                    performance: [ 'attendant' ],
                },
            },
            reportProcess: {
                icon: null,
                text: 'Business Process',
                route: 'admin.performance.implementation.business-process',
                role: {
                    performance: [ 'attendant' ],
                },
            },
            reportCompetency: {
                icon: null,
                text: 'Soft Competency',
                route: 'admin.performance.implementation.soft-competency',
                role: {
                    performance: [ 'attendant' ],
                },
            },
        }
    },
    reportPerformanceKpi: {
        icon: 'solution',
        text: 'Report',
        route: 'report-performance',
        role: {
            performance: [ 'attendant' ],
        },
        children: {
            reportMonthlyTarget: {
                icon: null,
                text: 'Realisasi Target Bulanan',
                route: 'admin.performance.report.monthly.target',
                role: {
                    performance: [ 'attendant' ],
                },
            },
            reportMonthlyPerformance: {
                icon: null,
                text: 'Nilai Kinerja Bulanan',
                route: 'admin.performance.report.monthly.performance',
                role: {
                    performance: [ 'attendant' ],
                },
            },
            summaryTarget: {
                icon: null,
                text: 'Summary Realisasi Target',
                route: 'admin.performance.report.summary.target',
                role: {
                    performance: [ 'attendant' ],
                },
            },
            summaryPerformance: {
                icon: null,
                text: 'Summary Nilai Kinerja',
                route: 'admin.performance.report.summary.performance',
                role: {
                    performance: [ 'attendant' ],
                },
            },
            summaryPerformanceKpi: {
                icon: null,
                text: 'Summary KPI Kinerja',
                route: 'admin.performance.report.summary.kpi.performance',
                role: {
                    performance: [ 'attendant' ],
                },
            },
        }
    },
}

export default attendant
